import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { colors } from 's1-ui';
import UserGuide from '../../../assets/UserGuide.pdf';

const { grayLight, buttonOrange } = colors;

const styles = {
  footer: {
    height: '30px',
    width: '100%',
    backgroundColor: '#1F2C38',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'fixed',
    bottom: 0,
    marginBottom: 0
  },
  text: {
    color: grayLight,
    fontSize: 13,
    marginRight: 5
  },
  link: {
    textDecoration: 'none',
    color: buttonOrange,
    fontSize: 13,
    marginRight: 5
  },
  pdf: {
    textDecoration: 'none',
    color: buttonOrange,
    fontSize: 13
  }
};

export const CCPFooter = ({ classes }) => (
  <footer className={ classes.footer }>
    <span className={ classes.text }>Get in touch with us at </span>
    <span><a href="mailto:fedexsupport@sovos.com" className={ classes.link }>FedExSupport@sovos.com</a></span>
    <span className={ classes.text }>or download the </span>
    <span><a href={ UserGuide } className={ classes.pdf }>User Guide</a></span>
  </footer>
);

CCPFooter.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(CCPFooter);
